import { SettingsLayout } from 'modules/settingsContainer/SettingsLayout';
import { DataTab } from 'modules/visualisations/Heatmap/settings/DataTab';
import { ViewTab } from 'modules/visualisations/Heatmap/settings/ViewTab';

export const HeatmapMainSettings = () => {
  return <SettingsLayout DataComponent={DataTab} ViewComponent={ViewTab} />;
};
